import { caepfService, type CaepfResponse } from '@/services';
import { useQuery } from '@tanstack/react-query';

/**
 * Consulta dados de CAEPF via Compliance.Api (proxy do Portal API).
 *
 * @param document - CAEPF com 14 dígitos (ou CPF com 11), somente números
 */
export function useCaepfLookup(document: string | undefined) {
  return useQuery<CaepfResponse | null>({
    queryKey: ['services', 'caepf', document],
    queryFn: async () => {
      if (!document) return null;

      const response = await caepfService.getCaepf(document);

      if (!response.success || !response.data) {
        throw new Error(
          response.error ?? 'Erro ao consultar CAEPF',
        );
      }

      return response.data;
    },
    enabled: !!document && (document.length === 11 || document.length === 14),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
